import Constants from 'expo-constants';
import Honeybadger from '@honeybadger-io/js';
import getEnvVars from '../../../environments';
const { monitorApiKey } = getEnvVars();

type Config = {
  apiKey: string;
  environment: string;
};
interface Context {
  user_email?: string;
  user_id?: string;
  user_type?: string;
}

export enum FingerPrint {
  artistDashboard = 'artistDashboard',
  artistAccount = 'artistAccount',
  auth = 'auth',
  fanListen = 'fanListen',
  fanAccount = 'fanAccount',
}
interface Notify {
  context?: Partial<Context>;
  fingerprint: FingerPrint;
  message?: string;
  name?: string;
}

class Monitor {
  configure() {
    const honeyBadgerEnv =
      Constants.manifest.extra.environment === 'beta'
        ? 'production'
        : 'development';
    const config: Config = {
      apiKey: monitorApiKey,
      environment: honeyBadgerEnv,
    };
    Honeybadger.configure({ ...config });
  }
  notify(e, notify: Notify): void {
    Honeybadger.notify(e, notify);
  }
  setContext(context: Context): void {
    Honeybadger.setContext({ ...context });
  }
}

const instance = new Monitor();
Object.freeze(instance);
export default instance;
